import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../../shared/models/auth.model';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectUser = createSelector(selectAuthState, (state) => state.user);
export const selectToken = createSelector(selectAuthState, (state) => state.token);
// export const selectRolePermissions = createSelector(selectAuthState, (state) => state.rolePermission);
export const selectLoading = createSelector(selectAuthState, (state) => state.loading);
export const selectError = createSelector(selectAuthState, (state) => state.error);

// derived selectors
// export const selectRoles = createSelector(selectRolePermissions, (rp) => rp?.roles || []);
// export const selectPermissions = createSelector(selectRolePermissions, (rp) => rp?.permissions || []);
